module.exports = __webpack_public_path__ + "img/jjhlogo2.6fce1e79.png";